import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-rock-preview',
  standalone: true,
  imports: [],
  templateUrl: './rock-preview.component.html',
  styleUrl: './rock-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RockPreviewComponent {
  @Input() thumbnailUrl: string | null = null;
  @Input() totalPorosity: string = '';
  @Input() showLegend: boolean = true;
  @Input() imageLabel: string = 'Segmented Rock Image';
  @Input() porosityLabel: string = 'Porosity:';
  @Input() showPorosity: boolean = true;
  @Input() additionalInfoLabel: string = '';
  @Input() additionalInfoValue: string = '';
  @Input() showAdditionalInfo: boolean = false;
}
